import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPreparedEmojiSecondary from './svgs/PreparedEmojiSecondary.js';
import SvgPreparedEmoji from './svgs/PreparedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var preparedEmoji = (props => useIcon(SvgPreparedEmoji, SvgPreparedEmojiSecondary, props));

export { preparedEmoji as default };
